import TermsAndConditions from '@module/terms-and-conditions';

export const init = () => {
  TermsAndConditions.configure();
};
